import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "phone",
    pure: true
})
export class PhonePipe implements PipeTransform {
    transform (phone: string) {
        if (phone) {
            const value = phone.toString().replace(/\D/g, "");

            if (value.length === 10) {
                const ddd = value.substring(0, 2);
                const firstPart = value.substring(2, 6);
                const secondPart = value.substring(6);
                return `(${ddd}) ${firstPart}-${secondPart}`;
            } else if (value.length === 11) {
                const ddd = value.substring(0, 2);
                const firstPart = value.substring(2, 3);
                const secondPart = value.substring(3, 7);
                const thirdPart = value.substring(7);
                return `(${ddd}) ${firstPart} ${secondPart}-${thirdPart}`;
            }
            return value;
        }
    }
}
